<template>
  <div>
    <div v-for="(item, index) in menus" :key="index">
      <el-menu-item v-if="!item.children" :index="item.index + item.text" @click="handleRoute(item)">
        <span>{{ item.text }}</span>
      </el-menu-item>
      <el-submenu v-else :index="item.index">
        <template slot="title">
          <i v-if="item.icon" :class="item.icon" />
          <span slot="title">{{ item.text }}</span>
        </template>
        <SidebarItem :menus="item.children" />
      </el-submenu>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    menus: {
      type: [Array, Object],
      required: true
    }
  },
  methods: {
    handleRoute(child) {
      this.$router.push({ path: child.index, query: child.link ? child.link.query : { status: 'NULL' } })
    }
  }
}
</script>
